import React, { useEffect, useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Solution } from './components/Solution';
import { Features } from './components/Features';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    setScrolled(latest > 50);
  });
  const navLinks = [{
    label: 'Problems',
    href: '#problems'
  }, {
    label: 'Solution',
    href: '#solution'
  }, {
    label: 'Features',
    href: '#features'
  }, {
    label: 'Pricing',
    href: '#pricing'
  }];
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-navy/80 backdrop-blur-xl border-b border-white/5 shadow-lg shadow-black/20' : 'bg-transparent'}`} initial={{
    y: -80
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5,
    ease: [0.22, 1, 0.36, 1]
  }} role="navigation" aria-label="Main navigation" data-id="element-0">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-1">
        <a href="#hero" className="font-display font-bold text-lg bg-gradient-to-r from-coral to-coral-light bg-clip-text text-transparent" data-id="element-2">
          Viveludique
        </a>

        <div className="hidden sm:flex items-center gap-8" data-id="element-3">
          {navLinks.map(link => <a key={link.href} href={link.href} className="font-body text-sm text-slate-400 hover:text-coral transition-colors duration-200" data-id="element-4">
              {link.label}
            </a>)}
        </div>

        <a href="#pricing" className="hidden sm:inline-flex items-center justify-center px-5 py-2 bg-gradient-to-r from-coral to-coral-light text-white font-body font-semibold rounded-full text-xs tracking-wide transition-all duration-300 hover:shadow-[0_0_20px_rgba(255,107,107,0.3)] hover:scale-105" data-id="element-5">
          Get Started
        </a>
      </div>
    </motion.nav>;
}
export function App() {
  return <div className="w-full min-h-screen bg-navy font-body text-slate-200" data-id="element-6">
      <Navbar data-id="element-7" />
      <Hero data-id="element-8" />
      <Problems data-id="element-9" />
      <Solution data-id="element-10" />
      <Features data-id="element-11" />
      <Pricing data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}